import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import DashboardLayout from '../../components/DashboardLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { AttendanceHistoryTable } from '../../components/AttendanceHistory';
import { toast } from 'sonner';
import { CheckSquare, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const YEAR_START = '2026-09-01';

const Attendance = () => {
    const [from, setFrom] = useState(YEAR_START);
    const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
    const [data, setData] = useState(null);
    const load = useCallback(async () => {
        try {
            const r = await axios.get(`${API_URL}/api/attendance/register/history`, { params: { date_from: from || undefined, date_to: to || undefined }, withCredentials: true });
            setData(r.data);
        } catch (e) { toast.error(e.response?.data?.detail || 'Failed to load attendance'); setData({ students: [] }); }
    }, [from, to]);
    useEffect(() => { load(); }, [load]);
    const kids = (data?.students || []).filter(s => s.status === 'active' || s.total > 0);

    return (
        <DashboardLayout>
            <div className="space-y-6" data-testid="attendance-page">
                <div><h1 className="text-2xl font-bold text-[#1F2937] font-['Outfit'] flex items-center gap-2"><CheckSquare className="h-6 w-6 text-[#064E3B]" />Attendance</h1>
                    <p className="text-[#4B5563]">Your children's attendance — click a child to see every recorded day</p></div>
                <Card className="card-surface"><CardContent className="p-4 flex flex-wrap gap-3 items-end">
                    <div className="space-y-1"><Label className="text-xs">From</Label><Input type="date" value={from} onChange={e => setFrom(e.target.value)} data-testid="parent-att-from" /></div>
                    <div className="space-y-1"><Label className="text-xs">To</Label><Input type="date" value={to} onChange={e => setTo(e.target.value)} data-testid="parent-att-to" /></div>
                </CardContent></Card>
                <Card className="card-surface"><CardContent className="p-0">
                    {data === null ? <div className="flex justify-center p-10"><Loader2 className="h-6 w-6 animate-spin text-[#064E3B]" /></div> : <AttendanceHistoryTable students={kids} showClass={false} />}
                </CardContent></Card>
            </div>
        </DashboardLayout>
    );
};

export default Attendance;
